import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import React from "react";

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

type CollapsibleContentProps = React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleContent> &
    PropsWithClassName;

const CollapsibleContent = React.forwardRef<
    React.ElementRef<typeof CollapsiblePrimitive.CollapsibleContent>,
    CollapsibleContentProps
>(({ className, ...props }, ref) => {
    return (
        <CollapsiblePrimitive.CollapsibleContent
            className={cn(
                "overflow-hidden data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown",
                className,
            )}
            {...props}
            ref={ref}
        />
    );
});

CollapsibleContent.displayName = CollapsiblePrimitive.Root.displayName;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
